import React from 'react';
import { Badge } from 'Components/frameworks/badge/Badge';
type TransferInDetailsProps = {
  iconName: IconName;
  description: string;
  detail: string;
};
export const TransferInDetails = ({ iconName, description, detail }: TransferInDetailsProps) => {
  return (
    <div data-testid="TransferInDetails" className="h-full bg-white">
      <div data-testid="TransferInDetails-icon" className="flex items-start gap-20">
        <Badge
          className="size-48 border-lightSand bg-lightSand text-black"
          iconName={iconName}
          iconSize="24px"
          variant="pill"
        />
        <div className="text-start text-16 leading-normal">
          <p className="mb-8">{description}</p>
          <p className="text-14 text-mediumGrey">{detail}</p>
        </div>
      </div>
    </div>
  );
};
